module.exports = __webpack_public_path__ + "images/backgrounds/purple-blur.e9ea5d1540f11ab0bc91.png";